export default __webpack_public_path__ + "static/media/leftGray.25e527d7.svg";